import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SpendingRequest  {
    _originalTypeClassName = "zERP.BO.SpendingRequest";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SpendingRequest.translate = translateService;
}
this.Details = [];
this.Entity = new Domain.BusinessEntity();
this.Budget = new Domain.Budget();
this.RelatedDocs = [];
this.FileUploads = [];
this.Id = null;
this.RequestedFrom = null;
this.Notes = null;
this.TotalAmount = null;
this.ApprovedAmount = null;
this.RemainingAmount = null;
this.BalanceChecked = false;
this.DateCreated = null;
this.DateIssued = null;
this.SystemDateApproved = null;
this.Invoiced = false;
this.InvoicedAmount = null;
this.DateInvoiced = null;
this.IsReleased = false;
this.DateReleased = null;
this.DateApproved = null;
this.ApprovalReference = null;
this.Status = null;
this.ProtocolNumber = null;
this.Number = null;
this.CanellationDate = null;
this.CancellationReason = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
RequestedFrom:any;
Notes:any;
TotalAmount:any;
ApprovedAmount:any;
RemainingAmount:any;
BalanceChecked:any;
DateCreated:any;
DateIssued:any;
SystemDateApproved:any;
Invoiced:any;
InvoicedAmount:any;
DateInvoiced:any;
IsReleased:any;
DateReleased:any;
DateApproved:any;
ApprovalReference:any;
Status:any;
ProtocolNumber:any;
Number:any;
CanellationDate:any;
CancellationReason:any;
Details:any;
IssuedBy:any;
ApprovedBy:any;
Entity:any;
Budget:any;
CreatedBy:any;
FiscalYear:any;
ReleasedBy:any;
Category:any;
SubCategory:any;
Department:any;
TransactionEntity:any;
RelatedDocs:any;
CurrentStep:any;
Owner:any;
FileUploads:any;
static setDetails = ($this, items) => {
                if (items == null) items = [];
                if ($this.Details == null) $this.Details = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Details.length > 0) {
                    Domain.SpendingRequest.removeDetails($this, $this.Details[0]);
                }

                Domain.SpendingRequest.addManyDetails($this, copyItems);
            }
static addManyDetails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.SpendingRequest.addDetails($this, items[i]);
                }
            }
static addDetails = ($this, item) => {
                if ($this.Details == null) $this.Details = [];
                if (item == null || $this.Details.indexOf(item) > -1) return;
                $this.Details.push(item);
if (item.SpendingRequest != $this) {
Domain.SpendingRequestDetail.setSpendingRequest(item, $this);
}
}
static addRangeDetails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.SpendingRequest.addDetails($this, item));
            }
static removeDetails = ($this, item) => {
                if ($this == null || $this.Details == null || $this.Details.indexOf(item) === -1) return;
                var _index = $this.Details.indexOf(item);
                $this.Details.splice(_index, 1);
item.SpendingRequest = null;
}
static clearDetails = ($this) => { $this.Details = null; }
static setIssuedBy = ($this, value) => {
var oldValue = $this.IssuedBy;
$this.IssuedBy = value;
if (value != null) {
}
}
static setApprovedBy = ($this, value) => {
var oldValue = $this.ApprovedBy;
$this.ApprovedBy = value;
if (value != null) {
}
}
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setBudget = ($this, value) => {
var oldValue = $this.Budget;
$this.Budget = value;
if (value != null) {
}
}
static setCreatedBy = ($this, value) => {
var oldValue = $this.CreatedBy;
$this.CreatedBy = value;
if (value != null) {
}
}
static setFiscalYear = ($this, value) => {
var oldValue = $this.FiscalYear;
$this.FiscalYear = value;
if (value != null) {
}
}
static setReleasedBy = ($this, value) => {
var oldValue = $this.ReleasedBy;
$this.ReleasedBy = value;
if (value != null) {
}
}
static setCategory = ($this, value) => {
var oldValue = $this.Category;
$this.Category = value;
if (value != null) {
}
}
static setSubCategory = ($this, value) => {
var oldValue = $this.SubCategory;
$this.SubCategory = value;
if (value != null) {
}
}
static setDepartment = ($this, value) => {
var oldValue = $this.Department;
$this.Department = value;
if (value != null) {
}
}
static setTransactionEntity = ($this, value) => {
var oldValue = $this.TransactionEntity;
$this.TransactionEntity = value;
if (value != null) {
}
}
static setRelatedDocs = ($this, items) => {
                if (items == null) items = [];
                if ($this.RelatedDocs == null) $this.RelatedDocs = [];

                const copyItems = Common.cloneObject(items);

                while ($this.RelatedDocs.length > 0) {
                    Domain.SpendingRequest.removeRelatedDocs($this, $this.RelatedDocs[0]);
                }

                Domain.SpendingRequest.addManyRelatedDocs($this, copyItems);
            }
static addManyRelatedDocs = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.SpendingRequest.addRelatedDocs($this, items[i]);
                }
            }
static addRelatedDocs = ($this, item) => {
                if ($this.RelatedDocs == null) $this.RelatedDocs = [];
                if (item == null || $this.RelatedDocs.indexOf(item) > -1) return;
                $this.RelatedDocs.push(item);
}
static addRangeRelatedDocs = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.SpendingRequest.addRelatedDocs($this, item));
            }
static removeRelatedDocs = ($this, item) => {
                if ($this == null || $this.RelatedDocs == null || $this.RelatedDocs.indexOf(item) === -1) return;
                var _index = $this.RelatedDocs.indexOf(item);
                $this.RelatedDocs.splice(_index, 1);
}
static clearRelatedDocs = ($this) => { $this.RelatedDocs = null; }
static setCurrentStep = ($this, value) => {
var oldValue = $this.CurrentStep;
$this.CurrentStep = value;
if (value != null) {
}
}
static setOwner = ($this, value) => {
var oldValue = $this.Owner;
$this.Owner = value;
if (value != null) {
}
}
static setFileUploads = ($this, items) => {
                if (items == null) items = [];
                if ($this.FileUploads == null) $this.FileUploads = [];

                const copyItems = Common.cloneObject(items);

                while ($this.FileUploads.length > 0) {
                    Domain.SpendingRequest.removeFileUploads($this, $this.FileUploads[0]);
                }

                Domain.SpendingRequest.addManyFileUploads($this, copyItems);
            }
static addManyFileUploads = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.SpendingRequest.addFileUploads($this, items[i]);
                }
            }
static addFileUploads = ($this, item) => {
                if ($this.FileUploads == null) $this.FileUploads = [];
                if (item == null || $this.FileUploads.indexOf(item) > -1) return;
                $this.FileUploads.push(item);
}
static addRangeFileUploads = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.SpendingRequest.addFileUploads($this, item));
            }
static removeFileUploads = ($this, item) => {
                if ($this == null || $this.FileUploads == null || $this.FileUploads.indexOf(item) === -1) return;
                var _index = $this.FileUploads.indexOf(item);
                $this.FileUploads.splice(_index, 1);
}
static clearFileUploads = ($this) => { $this.FileUploads = null; }

static IsViewMode($this: any): any{if (Domain.SpendingRequest.IsNew($this)) {return false;}
if ($this?.Status == Domain.BudgetStatus.Approved || $this?.Status == Domain.BudgetStatus.Canceled || $this?.Status == Domain.BudgetStatus.Rejected) {return true;}
if ($this?.CurrentStep != null && !($this?.CurrentStep?.IsAccepted)) {return true;}
return $this?.Owner != window._context.currentUser;
}
static UpdateAmounts($this: any): any{$this.TotalAmount = ($this?.Details?.linq?.any() ? $this?.Details?.linq?.sum((d) => d?.TotalAmount) : 0);
$this.ApprovedAmount = ($this?.Details?.linq?.any() ? $this?.Details?.linq?.sum((d) => d?.ApprovedAmount) : 0);
$this.InvoicedAmount = ($this?.Details?.linq?.any() ? $this?.Details?.linq?.sum((d) => d?.InvoicedAmount) : 0);
}
static Validate($this: any): any{}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}